import  { Product, Testimonial, Collection } from './types';

export const products: Product[] = [
  {
    id: 'p1',
    name: 'Diamond Eternity Ring',
    price: 1899,
    category: 'rings',
    material: 'gold',
    style: 'classic',
    images: [
      'https://images.unsplash.com/photo-1624492235740-c283aab78e45?ixid=M3w3MjUzNDh8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBqZXdlbHJ5JTIwZ29sZCUyMGRpYW1vbmQlMjByaW5ncyUyMG5lY2tsYWNlcyUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzQ5NzQ2NTUwfDA&ixlib=rb-4.1.0&fit=fillmax&h=600&w=800',
    ],
    description: 'An exquisite 18k gold ring featuring brilliant-cut diamonds set in a timeless eternity band design.',
    featured: true,
    bestSeller: true
  },
  {
    id: 'p2',
    name: 'Emerald Pendant Necklace',
    price: 2450,
    category: 'necklaces',
    material: 'gold',
    style: 'modern',
    images: [
      'https://images.unsplash.com/photo-1732704141783-571c1105f38f?ixid=M3w3MjUzNDh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBqZXdlbHJ5JTIwZ29sZCUyMGRpYW1vbmQlMjByaW5ncyUyMG5lY2tsYWNlcyUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzQ5NzQ2NTUwfDA&ixlib=rb-4.1.0&fit=fillmax&h=600&w=800',
    ],
    description: 'A stunning 18k gold necklace featuring a vibrant emerald pendant surrounded by diamond accents.',
    featured: true
  },
  {
    id: 'p3',
    name: 'Gold Tassel Bracelet',
    price: 1250,
    category: 'bracelets',
    material: 'gold',
    style: 'modern',
    images: [
      'https://images.unsplash.com/photo-1652340155016-e3c66dcba7f3?ixid=M3w3MjUzNDh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBqZXdlbHJ5JTIwZ29sZCUyMGRpYW1vbmQlMjByaW5ncyUyMG5lY2tsYWNlcyUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzQ5NzQ2NTUwfDA&ixlib=rb-4.1.0&fit=fillmax&h=600&w=800',
    ],
    description: 'A luxurious 18k gold bracelet featuring delicate tassel details, perfect for adding movement to any outfit.',
    bestSeller: true
  },
  {
    id: 'p4',
    name: 'Diamond Tennis Bracelet',
    price: 3200,
    category: 'bracelets',
    material: 'gold',
    style: 'classic',
    images: [
      'https://images.unsplash.com/photo-1666800715778-4b0409bb66bf?ixid=M3w3MjUzNDh8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBqZXdlbHJ5JTIwZ29sZCUyMGRpYW1vbmQlMjByaW5ncyUyMG5lY2tsYWNlcyUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzQ5NzQ2NTUwfDA&ixlib=rb-4.1.0&fit=fillmax&h=600&w=800',
    ],
    description: 'A timeless 18k gold tennis bracelet featuring 3 carats of brilliant-cut diamonds in a classic setting.',
    featured: true,
    new: true
  },
  {
    id: 'p5',
    name: 'Gold Kada Set',
    price: 4500,
    category: 'bracelets',
    material: 'gold',
    style: 'vintage',
    images: [
      'https://images.unsplash.com/photo-1728381031272-ba3f537feadd?ixid=M3w3MjUzNDh8MHwxfHNlYXJjaHw1fHxsdXh1cnklMjBqZXdlbHJ5JTIwZ29sZCUyMGRpYW1vbmQlMjByaW5ncyUyMG5lY2tsYWNlcyUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzQ5NzQ2NTUwfDA&ixlib=rb-4.1.0&fit=fillmax&h=600&w=800',
    ],
    description: 'Crafted from high-quality gold, this kada set features intricate designs that blend classic elegance with modern flair.',
    new: true
  },
  {
    id: 'p6',
    name: 'Diamond Drop Earrings',
    price: 2100,
    category: 'earrings',
    material: 'gold',
    style: 'classic',
    images: [
      'https://images.unsplash.com/photo-1721808085544-1cae3cd034e3?ixid=M3w3MjUzNDh8MHwxfHNlYXJjaHw2fHxsdXh1cnklMjBqZXdlbHJ5JTIwZ29sZCUyMGRpYW1vbmQlMjByaW5ncyUyMG5lY2tsYWNlcyUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzQ5NzQ2NTUwfDA&ixlib=rb-4.1.0&fit=fillmax&h=600&w=800',
    ],
    description: 'Elegant drop earrings featuring pear-shaped diamonds suspended from a delicate 18k gold chain.',
    featured: true,
    new: true
  },
  {
    id: 'p7',
    name: 'Stacked Diamond Bracelets',
    price: 5300,
    category: 'bracelets',
    material: 'gold',
    style: 'modern',
    images: [
      'https://images.unsplash.com/photo-1723361656145-b481be3f9e05?ixid=M3w3MjUzNDh8MHwxfHNlYXJjaHw3fHxsdXh1cnklMjBqZXdlbHJ5JTIwZ29sZCUyMGRpYW1vbmQlMjByaW5ncyUyMG5lY2tsYWNlcyUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzQ5NzQ2NTUwfDA&ixlib=rb-4.1.0&fit=fillmax&h=600&w=800',
    ],
    description: 'A luxurious set of stackable 18k gold bracelets adorned with pavé diamonds for maximum sparkle.',
    bestSeller: true
  },
  {
    id: 'p8',
    name: 'Vintage Jewelry Collection',
    price: 8900,
    category: 'necklaces',
    material: 'gold',
    style: 'vintage',
    images: [
      'https://images.unsplash.com/photo-1671513578788-a0129af392ce?ixid=M3w3MjUzNDh8MHwxfHNlYXJjaHw4fHxsdXh1cnklMjBqZXdlbHJ5JTIwZ29sZCUyMGRpYW1vbmQlMjByaW5ncyUyMG5lY2tsYWNlcyUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzQ5NzQ2NTUwfDA&ixlib=rb-4.1.0&fit=fillmax&h=600&w=800',
    ],
    description: 'A stunning collection of vintage-inspired jewelry pieces featuring antique design elements and classic craftsmanship.',
    featured: true
  },
  {
    id: 'p9',
    name: 'Traditional Bridal Set',
    price: 12500,
    category: 'necklaces',
    material: 'gold',
    style: 'vintage',
    images: [
      'https://images.unsplash.com/photo-1722410180687-b05b50922362?ixid=M3w3MjUzNDh8MHwxfHNlYXJjaHw5fHxsdXh1cnklMjBqZXdlbHJ5JTIwZ29sZCUyMGRpYW1vbmQlMjByaW5ncyUyMG5lY2tsYWNlcyUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzQ5NzQ2NTUwfDA&ixlib=rb-4.1.0&fit=fillmax&h=600&w=800',
    ],
    description: 'An exquisite bridal jewelry set featuring intricate craftsmanship and traditional design elements perfect for your special day.',
    new: true
  },
  {
    id: 'p10',
    name: 'Ruby Statement Necklace',
    price: 3750,
    category: 'necklaces',
    material: 'gold',
    style: 'vintage',
    images: [
      'https://images.unsplash.com/photo-1667013829921-b1c1719a0cfa?ixid=M3w3MjUzNDh8MHwxfHNlYXJjaHwxMHx8bHV4dXJ5JTIwamV3ZWxyeSUyMGdvbGQlMjBkaWFtb25kJTIwcmluZ3MlMjBuZWNrbGFjZXMlMjBjbG9zZSUyMHVwfGVufDB8fHx8MTc0OTc0NjU1MHww&ixlib=rb-4.1.0&fit=fillmax&h=600&w=800',
    ],
    description: 'A magnificent statement necklace featuring rich rubies set in intricate 18k gold filigree work.',
    bestSeller: true
  }
];

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    name: 'Emily Johnson',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=250&q=80',
    text: 'My Lustre & Co. engagement ring is absolutely stunning. The craftsmanship is impeccable, and I receive compliments on it constantly.',
    product: 'Diamond Eternity Ring'
  },
  {
    id: 't2',
    name: 'Michael Chen',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=250&q=80',
    text: "I purchased the emerald pendant for my wife's birthday, and she was brought to tears. The quality exceeds expectations, and the packaging was exquisite.",
    product: 'Emerald Pendant Necklace'
  },
  {
    id: 't3',
    name: 'Sophia Rodriguez',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=250&q=80',
    text: 'The gold tassel bracelet is the perfect everyday luxury piece. Its substantial without being overwhelming and adds elegance to any outfit.',
    product: 'Gold Tassel Bracelet'
  }
];

export const collections: Collection[] = [
  {
    id: 'c1',
    name: 'Celestial',
    image: 'https://images.unsplash.com/photo-1617038220319-276d3cfab638?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
    description: 'Inspired by the stars and cosmos, our Celestial collection features delicate star and moon motifs.'
  },
  {
    id: 'c2',
    name: 'Heritage',
    image: 'https://images.unsplash.com/photo-1737816473252-b7b8b60ae7b6?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    description: 'Our Heritage collection celebrates timeless designs with modern craftsmanship techniques.'
  },
  {
    id: 'c3',
    name: 'Botanical',
    image: 'https://images.unsplash.com/photo-1611085583191-a3b181a88401?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
    description: 'Featuring delicate floral and leaf motifs, our Botanical collection brings natural beauty to fine jewelry.'
  }
];

export const customPieces = [
  {
    id: 'custom1',
    name: 'Sapphire Heirloom Ring',
    image: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
    description: 'A custom-designed sapphire ring with antique filigree work, created to incorporate family gemstones.'
  },
  {
    id: 'custom2',
    name: 'Anniversary Diamond Necklace',
    image: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
    description: 'A bespoke diamond pendant necklace created to celebrate a 25th wedding anniversary.'
  },
  {
    id: 'custom3',
    name: 'Birthstone Family Bracelet',
    image: 'https://images.unsplash.com/photo-1602173574767-37ac01994b2a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
    description: 'A custom gold bracelet featuring the birthstones of each family member, arranged in a unique constellation pattern.'
  }
];

// Design process steps for animation
export const designProcessSteps = [
  {
    id: 1,
    title: "Initial Consultation",
    description: "We begin with a detailed conversation to understand your vision, preferences, and budget.",
    icon: "MessageCircle",
    image: "https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 2,
    title: "Design & Sketch",
    description: "Our designers create detailed sketches based on your input, refining until perfect.",
    icon: "Edit",
    image: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 3,
    title: "Material Selection",
    description: "Choose from our curated selection of precious metals and gemstones.",
    icon: "Filter",
    image: "https://images.unsplash.com/photo-1583937443566-6fe1a1c6e400?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 4,
    title: "Crafting",
    description: "Our master jewelers handcraft your piece with meticulous attention to detail.",
    icon: "Tool",
    image: "https://images.unsplash.com/photo-1588599376442-3cbf9c67449e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 5,
    title: "Delivery",
    description: "Your finished piece is presented in our signature packaging, ready to be treasured.",
    icon: "Gift",
    image: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80"
  }
];

// Lookbook gallery images
export const lookbookImages = [
  {
    id: 'l1',
    src: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
    alt: 'Diamond engagement ring',
    category: 'rings'
  },
  {
    id: 'l2',
    src: 'https://images.unsplash.com/photo-1610694955371-d4a3e0ce4b52?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
    alt: 'Gold bracelets',
    category: 'bracelets'
  },
  {
    id: 'l3',
    src: 'https://images.unsplash.com/photo-1600721391776-b5cd0e0048f9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
    alt: 'Pearl earrings',
    category: 'earrings'
  },
  {
    id: 'l4',
    src: 'https://images.unsplash.com/photo-1583937443566-6fe1a1c6e400?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
    alt: 'Gold necklace',
    category: 'necklaces'
  },
  {
    id: 'l5',
    src: 'https://images.unsplash.com/photo-1630019852942-f89202989a59?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
    alt: 'Diamond rings',
    category: 'rings'
  },
  {
    id: 'l6',
    src: 'https://images.unsplash.com/photo-1573408301185-9146fe634ad0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
    alt: 'Gold bracelet',
    category: 'bracelets'
  },
  {
    id: 'l7',
    src: 'https://images.unsplash.com/photo-1602173574767-37ac01994b2a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
    alt: 'Pearl necklace',
    category: 'necklaces'
  },
  {
    id: 'l8',
    src: 'https://images.unsplash.com/photo-1610694955371-d4a3e0ce4b52?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
    alt: 'Diamond pendant',
    category: 'necklaces'
  },
  {
    id: 'l9',
    src: 'https://images.unsplash.com/photo-1611085583191-a3b181a88401?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
    alt: 'Diamond earrings',
    category: 'earrings'
  }
];
 